
import { useTitle } from '@vueuse/core';
import { currentSiteName } from '@/utils/tools';

const pageTitle = useTitle();
let projectName = currentSiteName();
interface metaData {
  title?: string,
  rawTitle?: string,
  name?: string,
  description?: string,
  keywords?: string
};
export const usePageMeta = (data: metaData, pageSuffix?: string) => {
  if (pageSuffix) {
    projectName = pageSuffix;
  }
  if (data.rawTitle) {
    pageTitle.value = data.rawTitle;
  } else if (data.title && data.name) {
    pageTitle.value = `${data.title} - ${data.name} - ${projectName}`;
  } else {
    pageTitle.value = data.title ? `${data.title} - ${projectName}` : (data.name ? `${data.name} - ${projectName}` : `${currentSiteName()} - 全球开发者的开源社区,开源代码托管平台`);
  }
  if (data.description || data.description === '') {
    const metaDescription = <HTMLElement>document.querySelector('meta[name="description"]');
    metaDescription.setAttribute('content', data?.description || '');
  }
  if (data.keywords || data.keywords === '') {
    const metaKeywords = <HTMLElement>document.querySelector('meta[name="keywords"]');
    metaKeywords.setAttribute('content', data.keywords || '');
  }
  return pageTitle.value;
};
